import React from "react";
import styles from "./CustomPagination.module.scss";

const CustomPagination = ({ currentPage, totalPages, onPageChange }) => {
  const handlePrevious = () => {
    if (currentPage > 0) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages - 1) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <div className={styles.pagination}>
      <button
        className={`px-3 ${styles.pageButton}`}
        onClick={handlePrevious}
        disabled={currentPage === 0}
      >
        {/* &lt; */}
        Previous
      </button>
      <button
        className={`px-4 ${styles.pageButton}`}
        onClick={handleNext}
        disabled={currentPage === totalPages - 1}
      >
        {/* &gt; */}
        Next
      </button>
    </div>
  );
};

export default CustomPagination;
